/**
 * TierBadge — neon chip showing a team's MMR tier (Bronze→Champion).
 * Mirrors the driftleague.co badge convention. Reads the tier dict
 * straight off `team.tier` (server-enriched via services/mmr.py) so the
 * thresholds stay in one place.
 */
import React from "react";

const FALLBACK = {
  id: "bronze", name: "Bronze", color: "#14b8a6", badge: "🥉", min_mmr: 0,
};

export function TierBadge({ tier, mmr, compact = false, testid }) {
  const t = tier || FALLBACK;
  return (
    <span
      data-testid={testid || `tier-badge-${t.id}`}
      title={`${t.name} · ${mmr ?? "—"} MMR`}
      className={
        "inline-flex items-center gap-1 rounded-full font-bold uppercase " +
        (compact ? "text-[9px] px-1.5 py-[1px]" : "text-[10px] px-2 py-0.5")
      }
      style={{
        color: t.color,
        background: `${t.color}1a`,
        border: `1px solid ${t.color}55`,
        letterSpacing: "0.12em",
      }}
    >
      <span aria-hidden>{t.badge}</span>
      <span>{t.name}</span>
      {mmr != null && !compact && (
        <span className="text-white/55 ml-1 font-mono">{mmr}</span>
      )}
    </span>
  );
}

export default TierBadge;
